<template>
	<img v-bind="{src: _srcset, srcset: _srcset}"/>
</template>

<script>
export default {
	props: {
		img: {type: Object, required: false},
		src: {type: String, required: false},
		srcset: {type: Object, required: false},
		sizes: {type: Object, required: false}
	},
	computed: {
		_src: (t) => t.src || t.img.images.slice(-1)[0].path,
		_srcset: (t) => t.srcset || t.img.srcSet
	}
};
</script>

<style  lang="scss" scoped>
img {

}
</style>
